import {
  EIconButtonSize,
  EIconButtonVariant,
  GeneralCaretLeftIcon,
  GeneralShareInitialIcon,
  IconButton,
} from '@outdoorsyco/bonfire';
import NextLink from 'next/link';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { FavoriteButton } from '@/components/common/FavoriteButton';
import MaxWidth from '@/components/common/layout/MaxWidth';
import { WishlistModalWrapper } from '@/components/wishlists/WishlistModal';
import { IFavorite } from '@/redux/modules/wishlists';
import { getUserFavorites } from '@/redux/selectors/favorites';
import { EListingSource } from '@/services/analytics/listings/types';
import { ICampgroundData } from '@/services/types/search/campgrounds/id';

type THeaderActionsProps = {
  title: string;
  description: string;
  backUrl: string;
  campground?: ICampgroundData;
  noSectionWrapper?: boolean;
};

export const HeaderActions = ({
  title,
  description,
  backUrl,
  campground,
  noSectionWrapper = false,
}: THeaderActionsProps) => {
  const [isShareOpen, setIsShareOpen] = useState(false);
  const favorites = useSelector(getUserFavorites);
  const isFavorite =
    favorites && favorites.escapes?.some((f: IFavorite) => f?.item_id === Number(campground?.id));

  const handleShare = () => {
    if (window?.navigator && window?.navigator.share) {
      window.navigator.share({
        title,
        text: description,
        url: window.location.href,
      });
    } else {
      setIsShareOpen(!isShareOpen);
    }
  };

  const headerActionContent = (
    <>
      <div className="relative flex justify-between py-4 pointer-events-none [&>*]:pointer-events-auto">
        <NextLink href={backUrl} passHref legacyBehavior>
          <IconButton
            icon={GeneralCaretLeftIcon}
            size={EIconButtonSize.Medium}
            variant={EIconButtonVariant.Primary}
            className="!text-2xl"
          />
        </NextLink>

        <div className="relative flex pointer-events-none gap-2 [&>*]:pointer-events-auto">
          <IconButton
            onClick={handleShare}
            icon={GeneralShareInitialIcon}
            size={EIconButtonSize.Medium}
            variant={EIconButtonVariant.Primary}
            className="!text-2xl"
          />
          {campground && (
            <WishlistModalWrapper
              isFavorite={isFavorite}
              item={campground}
              itemType="escape"
              wishlistingEventData={{ eventSource: EListingSource.VACATION_PACKAGES }}
              TriggerComponent={({ isFavorite: isWishlisted, toggleFavorite }) => (
                <FavoriteButton
                  isFavorite={isWishlisted}
                  onClick={toggleFavorite}
                  hideFavoriteCount
                  size={24}
                />
              )}
            />
          )}
        </div>
      </div>
    </>
  );
  return noSectionWrapper ? (
    headerActionContent
  ) : (
    <section>
      <MaxWidth className="mx-auto">{headerActionContent}</MaxWidth>
    </section>
  );
};
